/* Auth token store + session events.
 *
 * Token storage strategy: localStorage for v1. Documented XSS risk —
 * mitigated by strict CSP (no unsafe-eval) and DOMPurify on any user
 * content. Move to httpOnly cookie + CSRF token before payments go live.
 */

const TOKEN_KEY = 'rekraft.session';
const listeners = new Set();

let cache = null;

function read() {
  if (cache !== null) return cache;
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    cache = raw ? JSON.parse(raw) : null;
  } catch {
    cache = null;
  }
  return cache;
}

function write(session) {
  cache = session;
  try {
    if (session) localStorage.setItem(TOKEN_KEY, JSON.stringify(session));
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* quota / private mode — non-fatal */ }
  for (const fn of listeners) try { fn(session); } catch { /* listener bug */ }
}

export function getSession()  { return read(); }
export function getToken()    { return read()?.token ?? null; }
export function getUserId()   { return read()?.userId ?? null; }
export function isSignedIn()  { return !!getToken(); }

export function setSession(session) {
  // session: { token, userId, phone, expiresAt? }
  write(session);
}

export function clearSession() {
  write(null);
}

/** Subscribe to session changes — returns unsubscribe fn. */
export function onSessionChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
